<template>
    <v-layout row wrap>
        <v-form ref="registrationForm" @submit.prevent>
            <v-flex xs12 py-0>
                <p class="title">{{ "Registration form" | translation }}</p>
            </v-flex>

            <v-flex xs12 py-0>
                <v-text-field
                    v-model="username"
                    :rules="[rules.required, rules.email]"
                    :label="`${$language.translate('Email')}*`"
                    required
                    :error-messages="errors['username']"
                    @change="resetErrors('username')"
                ></v-text-field>
            </v-flex>

            <v-flex xs12 py-0>
                <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                    :rules="[rules.required, rules.length]"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    :label="`${$language.translate('Password')}*`"
                    required
                    browser-autocomplete="new-password"
                    :error-messages="errors['password']"
                    @change="resetErrors('password')"
                ></v-text-field>
            </v-flex>

            <v-flex xs12 py-0>
                <v-checkbox
                    class="d-inline-block mt-0"
                    :disabled="loading"
                    v-model="agb"
                    :rules="[rules.agb]"
                    required
                >
                    <div slot="label">
                        <component :is="{template: '<span>' + $language.translate('I agree with the registration conditions') + '</span>'}"/>
                    </div>
                </v-checkbox>
            </v-flex>

            <v-flex xs12 py-0>
                <v-btn
                    @click="submit"
                    class="primary"
                    :loading="loading"
                >{{ 'Submit' | translation }}</v-btn>
            </v-flex>
        </v-form>

        <registration-success-modal v-model="displayModal" :message="modalMessage"/>
    </v-layout>
</template>

<script>
import { mapActions } from 'vuex';
import { eventManager } from '@breakmedia/prime-vue-event-manager';

export default {
    name: 'CustomerRegistration',
    data() {
        return {
            username: null,
            password: null,
            loading: false,
            agb: false,
            showPassword: false,
            rules: {
                required: value =>
                    !!value || this.$language.translate('Dieses Feld wird benötigt und darf nicht leer sein.'),
                length: value =>
                    value
                        ? value.length >= 7 || this.$language.translate('Das Passwort muss mindestens 7 Zeichen haben.')
                        : '',
                email: value =>
                    /.+@.+/.test(value) || this.$language.translate('Bitte geben sie eine gültige Email-Adresse ein.'),
                agb: value => !!value || 'Confirmation is required',
            },
            errors: {},
            displayModal: false,
            modalMessage: '',
        };
    },
    methods: {
        ...mapActions('Customer', ['registerCustomer']),
        submit() {
            this.resetErrors();

            if (this.$refs.registrationForm.validate()) {
                this.loading = true;

                this.registerCustomer(this.getCustomerData())
                    .then(result => {
                        if (result.success === true) {
                            eventManager.$emit('registrationComplete');
                            this.onRegistrationSuccess(result);
                        } else if (result.errors) {
                            if (typeof result.errors === 'string') {
                                this.modalMessage = result.errors;
                                this.displayModal = true;
                            } else {
                                Object.keys(result.errors).forEach(key => {
                                    this.errors[key] = result.errors[key];
                                });
                            }
                        } else if (result.success === false) {
                            this.modalMessage = 'An unexpected problem occurred. Please try again later.';
                            this.displayModal = true;
                        }
                    })
                    .catch(err => {
                        this.modalMessage = 'An unexpected problem occurred. Please try again later.';
                        this.displayModal = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        resetErrors() {
            this.errors = {};
        },
        getCustomerData() {
            return {
                username: this.username,
                password: this.password,
            };
        },
        onRegistrationSuccess() {
            this.modalMessage = 'REGISTRATION_SUCCESS_MESSAGE';
            this.displayModal = true;
        },
    },
};
</script>
